import "core-js/modules/es.function.name.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-31e2b7ae"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_createTextVNode(" 首页 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

  return _openBlock(), _createBlock(_component_el_breadcrumb, {
    "separator-icon": _ctx.ArrowRight
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_breadcrumb_item, {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.jum();
        })
      }, {
        default: _withCtx(function () {
          return [_hoisted_1];
        }),
        _: 1
      }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.a, function (item) {
        return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: item,
          onClick: function onClick($event) {
            return _ctx.jump(item);
          }
        }, {
          default: _withCtx(function () {
            return [_createTextVNode(_toDisplayString(item.name), 1)];
          }),
          _: 2
        }, 1032, ["onClick"]);
      }), 128))];
    }),
    _: 1
  }, 8, ["separator-icon"]);
}